<blockable-div id="commercial-contact-details-container" #details>
  <app-progress-spinner [enabled]="!contact()" />
  <p-blockUI [blocked]="saving() || isLoading()" [target]="details" />
  @if (contact(); as contact) {
    <div id="commercial-contact-details">
      <div id="commercial-contact-action-buttons">
        <div class="xtra-small-top-padding">
          <h2>{{ contact.firstName }} {{ contact.lastName }}</h2>
        </div>
        <div class="no-padding">
          <div class="button-wrapper no-padding">
            @if (actions().length > 0) {
              <div class="no-padding-top-bottom align-left">
                <p-select
                  #dd
                  [options]="actions()"
                  [ngModel]="selectedAction()"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="selectedAction.set($event)"
                  (onChange)="actionEvent($event, dd)"
                  appendTo="body"
                  class="action-drop-down"
                />
              </div>
            }
            @if (
              !isHistoricalRecord() &&
              ((contact.id && canEdit()) || (!contact.id && canCreate()))
            ) {
              <div>
                <app-progress-spinner [enabled]="saving()" />
              </div>
              <div id="save-btn" class="no-padding-top-bottom">
                <button
                  pButton
                  label="{{ 'COMMON.LABEL.BUTTONS.SAVE' | translate }}"
                  icon="fa fa-fw fa-save"
                  (click)="saveContact()"
                  [disabled]="!formDirty() || saving()"
                ></button>
              </div>
            }
          </div>
        </div>
      </div>
      <hr id="commercial-contact-scroll-divider" />
      <p-scrollPanel class="commercial-contact-scroll-panel">
        <app-commercial-contact-form
          [form]="formState()"
          [contact]="contact"
          [availableCompanies]="companyOptions()"
          [availableJobRoles]="availableJobRoles()"
          [writeAccess]="
            !isHistoricalRecord() && (contact.id ? canEdit() : canCreate())
          "
          [validationMessages]="validationMessages"
          #ccf
        />
      </p-scrollPanel>
    </div>
  }
</blockable-div>
